
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import EloscaCRMLayout from "../EloscaCRMLayout";
import EnquiryList from "../enquiry/pages/EnquiryList";
import CreateEnquiry from "../enquiry/pages/CreateEnquiry";
import EnquiryWorkspace from "../enquiry/pages/EnquiryWorkspace";

export default function EloscaCRMRoutes() {
  return (
    <Routes>
      <Route element={<EloscaCRMLayout />}>
        {/* Default ELOSCA CRM page */}
        <Route
          index
          element={<Navigate to="enquiry" replace />}
        />

        {/* Enquiry List */}
        <Route
          path="enquiry"
          element={<EnquiryList />}
        />

        {/* Create Enquiry */}
        <Route
          path="enquiry/create"
          element={<CreateEnquiry />}
        />

        {/* Detailed Enquiry Workspace */}
        <Route
          path="enquiry/:enquiryId"
          element={<EnquiryWorkspace />}
        />

        {/* Fallback for unknown ELOSCA CRM routes */}
        <Route
          path="*"
          element={
            <Navigate to="/elosca-crm/enquiry" replace />
          }
        />
      </Route>
    </Routes>
  );
}
